import { AccordionWithToggleVariantType } from '../../variants';
import { commonStyles } from '../commonStyles';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [AccordionWithToggleVariantType.REGULAR]: {
            ...commonStyles(FOUNDATIONS, FONT),
        },
    };
};
//# sourceMappingURL=regular.js.map